<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ChangeFarmMixin',

  computed: {
    ...mapGetters('farms', ['currentFarm']),
  },

  methods: {
    ...mapActions('catalog', {
      fetchCatalogFilters: 'fetchFilters',
      fetchCatalogList: 'fetchCatalogList',
    }),
    ...mapActions('cultivares', {
      fetchSeasonCropVarieties: 'fetchSeasonCropVarieties',
      getSeedsBySelectedCrop: 'getSeedsBySelectedCrop',
      resetVarietiesStore: 'resetStore',
    }),
    ...mapActions('execucoes', {
      loadProgramasPlanejados: 'loadProgramasPlanejados',
      resetExecutionStore: 'resetStore',
    }),
    ...mapActions('farms', ['setFarm', 'setLoadingChangeFarm']),
    ...mapActions('notes', {
      fetchNotes: 'fetchNotes',
      resetNotesStore: 'resetStore',
    }),
    ...mapActions('plot', ['getPlots']),
    ...mapActions('semeaduras', ['loadSowingsFilter']),
    async changeFarm(farm) {
      if (farm.id === this.currentFarm.id) return

      this.setLoadingChangeFarm(true)

      this.setFarm(farm.id)

      this.handleRouteRedirection(farm.id)

      await this.loadFarmRelatedData(farm.id)

      await this.handleRouteSpecificData(farm.id)

      this.resetExecutionStore()
      this.handleVarietiesReset()

      this.setLoadingChangeFarm(false)
    },
    handleVarietiesReset() {
      const excludedRoutes = [
        '/cultivares',
        '/programas',
        '/sowings',
        '/performance',
        '/comparacao',
      ]

      if (!excludedRoutes.includes(this.$route.path)) {
        this.resetVarietiesStore()
      }
    },
    handleRouteRedirection(farmId) {
      if (this.$route.path === '/plot') {
        this.redirectToHome(farmId)
      } else {
        this.$router.replace({ query: { fazenda_id: farmId } })
      }
    },
    async handleRouteSpecificData(farmId) {
      if (this.$route.path === '/notes') {
        const notesParams = { farmId }
        await this.fetchNotes(notesParams)
      } else {
        this.resetNotesStore()
      }

      if (this.$route.path === '/comparacao') {
        this.redirectToPrograms()
      }

      if (this.$route.path === '/execucao') {
        this.redirectToSowings(farmId)
      }

      if (this.$route.path === '/catalog') {
        await this.fetchCatalogFilters()
        await this.fetchCatalogList()
      }

      if (this.$route.path === '/cultivares') {
        this.getSeedsBySelectedCrop(farmId)
      } else if (
        ['/sowings', '/performance', '/programas'].includes(this.$route.path)
      ) {
        this.fetchSeasonCropVarieties(farmId)
        if (this.$route.path === '/programas') {
          // Temporary fix for programs page
          this.$root.$emit('reset-program-variety')
        }
      }
    },
    async loadFarmRelatedData(farmId) {
      const fieldParams = { farmId }
      await Promise.allSettled([
        this.getPlots(fieldParams),
        this.loadSowingsFilter(),
      ])
    },
    redirectToHome(farmId) {
      this.$router.push({
        path: '/my_farm',
        query: { fazenda_id: farmId },
      })
    },
    redirectToPrograms() {
      this.$router.push({
        path: 'programas',
      })
    },
    redirectToSowings(farmId) {
      this.$router.push({
        path: 'sowings',
        query: { fazenda_id: farmId },
      })
    },
  },
}
</script>
